{
  "agb-to-accept-dialog": {
    "buttons": {
      "agree": "Souhlasím",
      "deny-and-logout": "Odmítnutí a odhlášení"
    },
    "text": {
      "agb": "Všeobecné obchodní podmínky (VOP)"
    }
  }
}
